import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { WhisperComponent } from './WhisperComponent';

interface Props {
	title: string | JSX.Element;
	additionalClass: string;
	tooltipText?: string;
	containerAdditionalClass?: string;
}

export const Title = (props: Props): React.ReactElement => {
	const { additionalClass, containerAdditionalClass, title, tooltipText } = props;

	return (
		<div className={clsx(
			containerAdditionalClass,
			tooltipText && 'd-flex align-items-center'
		)}>
			<div className={clsx(additionalClass)}>
				{title}
			</div>
			{
				tooltipText && (
					<WhisperComponent
						isTooltip
						whisperText={tooltipText}
						mainText={
							<FontAwesomeIcon
								icon={faQuestionCircle}
								className="cursor-pointer ms-1"
								width={12}
							/>
						}
					/>
				)
			}
		</div>
	);
};
